export function capitalize(value: string): string {
  return value.charAt(0).toUpperCase() + value.slice(1);
}

export function initials(email: string): string {
  return email.slice(0, 2).toUpperCase();
}

export function escapeHtml(value: string): string {
  return value.replace(/[&<>'"]/g, character => ({
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    "'": "&#39;",
    '"': "&quot;",
  })[character]!);
}

export function highlightMatch(value: string, search: string): string {
  const needle = search.trim();
  if (!needle) return escapeHtml(value);
  const source = value.toLocaleLowerCase();
  const normalizedNeedle = needle.toLocaleLowerCase();
  let cursor = 0;
  let result = "";
  while (cursor < value.length) {
    const index = source.indexOf(normalizedNeedle, cursor);
    if (index < 0) return result + escapeHtml(value.slice(cursor));
    result += `${escapeHtml(value.slice(cursor, index))}<mark class="search-match">${escapeHtml(value.slice(index, index + needle.length))}</mark>`;
    cursor = index + needle.length;
  }
  return result;
}
